const API_URL = "https://www.dupaws.com/services/api/account/Register/";

const LOGIN_URL = "https://www.dupaws.com/services/Token";
const LOGINEXTERNAL_URL =
  "https://www.dupaws.com/services/api/account/RegisterExternalToken";
const SIGNUP_URL = API_URL + "users/";

import JQuery from "jquery";
import store from "../data/store";
import router from "../router/index";

export default {
  register(context, creds, redirect) {
    var self = this;
    var credentials =
      "grant_type=password&username=" +
      encodeURIComponent(creds.Email) +
      "&password=" +
      encodeURIComponent(creds.Password) +
      "&FirstName=" +
      encodeURIComponent(creds.FirstName) +
      "&LastName=" +
      encodeURIComponent(creds.LastName);
    var loginCreds = {
      grant_type: "password",
      username: creds.Email,
      password: creds.Password,
      FirstName: creds.FirstName,
      LastName: creds.LastName,
    };
    context.error = "";
    context.notification = "Registering account..";
    $.ajax({
      type: "POST",
      url: API_URL,
      data: JSON.stringify(creds),
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        context.notification = data;
        context.error = "";
        //router.push({path: redirect})
        if (creds.userRole == "Sitter") {
          fbq("track", "CompleteRegistration", {
            content_name: "Sitter registration",
          });
          context.$ga.event("Signup Complete", "Sitter registration");
        } else {
          fbq("track", "CompleteRegistration", {
            content_name: "Client registration",
          });
          context.$ga.event("Signup Complete", "Client registration");
        }
        self.login(context, loginCreds, redirect);
      },
      error: function (data, status, error) {
        try {
          context.notification = "";
          context.error = data.responseJSON.ModelState[""][0];
        } catch (e) {
          context.notification = "";
          context.error =
            "Oops we are having error with your registration, server is not reachable..";
        }
      },
    });
  },
  login(context, loginCreds, redirect) {
    context.error = "";
    context.notification = "Logging you in";
    $.ajax({
      type: "POST",
      headers: {
        "Content-Type": "x-www-form-urlencoded",
      },
      url: LOGIN_URL,
      data: loginCreds,
      success: function (data) {
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("email", data.userName);
        localStorage.setItem("loggedDate", JSON.stringify(moment()));
        store.commit("email", data.userName);

        if (data.phoneConfirmed == "True" || data.phoneConfirmed == "true") {
          localStorage.setItem("phoneConfirmed", "True");
          store.commit("phoneConfirmed", true);
        } else {
          localStorage.setItem("phoneConfirmed", "False");
          store.commit("phoneConfirmed", false);
        }
        localStorage.setItem("firstName", data.firstName);
        localStorage.setItem("lastName", data.lastName);
        localStorage.setItem("doubleRole", data.doubleRole);
        store.commit("firstName", localStorage.getItem("firstName"));
        store.commit("lastName", localStorage.getItem("lastName"));
        localStorage.setItem("userRole", data.userRole);
        if (data.userRole == "Sitter") {
          localStorage.setItem("sitterId", data.sitterId);
          store.commit("sitterId", localStorage.getItem("sitterId"));

          if (data.CountryId != null) {
            localStorage.setItem("CountryId", data.CountryId);
          }
        }
        if (data.userRole == "Client") {
          localStorage.setItem("customerId", data.customerId);
          store.commit("customerId", localStorage.getItem("customerId"));
        }

        localStorage.setItem("emailConfirmed", data.emailConfirmed);
        localStorage.setItem("expires", data.expires_in);
        localStorage.setItem("profilePicUrl", data.profilePicUrl);

        store.commit("profilePicUrl", data.profilePicUrl);
        store.commit("userRole", data.userRole);
        store.commit("authCheck", true);

        if (redirect != null) {
          router.push({ path: "/" + redirect });
          router.go({ path: "/" + redirect }); //workaround to make page refresh after login for signalR
        } else {
          router.push({ path: "/" });
          router.go({ path: "/" }); //used to init user data such as notifications and whats not..
        }
      },
      error: function (data, status, error) {
        try {
          context.notification = "";
          context.error = data.responseJSON.error_description;
        } catch (e) {
          context.notification = "";
          context.error =
            "Oops we are having problem logging to the server, please try again in a moment..";
        }
      },
    });
  },
  fbLogin(context, FBTokenInfo, redirect) {
    context.notification = "Logging you in";
    context.error = "";
    $.ajax({
      type: "POST",
      url: LOGINEXTERNAL_URL,
      data: FBTokenInfo,
      success: function (data) {
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("loggedDate", JSON.stringify(moment()));
        localStorage.setItem("firstName", data.firstName);
        localStorage.setItem("emailConfirmed", data.emailConfirmed);
        if (data.phoneConfirmed == "True" || data.phoneConfirmed == "true") {
          localStorage.setItem("phoneConfirmed", "True");
          store.commit("phoneConfirmed", true);
        } else {
          localStorage.setItem("phoneConfirmed", "False");
          store.commit("phoneConfirmed", false);
        }
        localStorage.setItem("lastName", data.lastName);
        localStorage.setItem("firstName", data.firstName);
        localStorage.setItem("doubleRole", data.doubleRole);
        localStorage.setItem("lastName", data.lastName);
        if (data.CountryId != null) {
          localStorage.setItem("CountryId", data.CountryId);
        }
        store.commit("firstName", localStorage.getItem("firstName"));
        store.commit("lastName", localStorage.getItem("lastName"));
        localStorage.setItem("expires", data.expires_in);
        localStorage.setItem("email", data.userName);
        store.commit("email", localStorage.getItem("email"));
        localStorage.setItem("userRole", data.userRole);

        if (data.userRole == "Sitter") {
          localStorage.setItem("sitterId", data.sitterId);
          store.commit("sitterId", localStorage.getItem("sitterId"));
        }
        if (data.userRole == "Client") {
          localStorage.setItem("customerId", data.customerId);
          store.commit("customerId", localStorage.getItem("customerId"));
        }
        localStorage.setItem("profilePicUrl", data.profilePicUrl);
        store.commit("profilePicUrl", data.profilePicUrl);
        store.commit("userRole", data.userRole);
        store.commit("authCheck", true);

        if (redirect) {
          router.push({ path: "/" + redirect });
          router.go({ path: "/" + redirect }); //workaround to make page refresh after login for signalR
        } else {
          router.push({ path: "/" });
          router.go({ path: "/" });
        }
      },
      error: function (data, status, error) {
        try {
          context.notification = "";
          context.error = data.responseJSON.error_description;
        } catch (e) {
          context.notification = "";
          context.error =
            "Oops we are having problem logging to the server, please try again in a moment..";
        }
      },
    });
  },
  logout() {
    var self = this;
    if (localStorage.getItem("logged_as") !== null) {
      localStorage.removeItem("logged_as");
    }
    if (localStorage.getItem("loggedDate") !== null) {
      localStorage.removeItem("loggedDate");
    }
    if (localStorage.getItem("user_role") !== null) {
      localStorage.removeItem("user_role");
    }
    if (localStorage.getItem("access_token") != null) {
      localStorage.removeItem("access_token");
    }
    if (localStorage.getItem("firstName") != null) {
      localStorage.removeItem("firstName");
    }

    if (localStorage.getItem("expires") != null) {
      localStorage.removeItem("expires");
    }

    if (localStorage.getItem("doubleRole") != null) {
      localStorage.removeItem("doubleRole");
    }

    if (localStorage.getItem("phoneNumber") != null) {
      localStorage.removeItem("phoneNumber");
    }

    if (localStorage.getItem("phoneConfirmed") != null) {
      localStorage.removeItem("phoneConfirmed");
    }

    if (sessionStorage.getItem("SessionId") != null) {
      //sessionStorage not localStorage!!
      sessionStorage.removeItem("SessionId");
    }

    if (localStorage.getItem("email") != null) {
      localStorage.removeItem("email");
    }

    if (localStorage.getItem("lastName") != null) {
      localStorage.removeItem("lastName");
    }

    if (localStorage.getItem("profilePicUrl") != null) {
      localStorage.removeItem("profilePicUrl");
    }

    if (localStorage.getItem("sitterId") != null) {
      localStorage.removeItem("sitterId");
    }

    if (localStorage.getItem("customerId") != null) {
      localStorage.removeItem("customerId");
    }

    if (localStorage.getItem("emailConfirmed") != null) {
      localStorage.removeItem("emailConfirmed");
    }

    if (localStorage.getItem("userRole") != null) {
      localStorage.removeItem("userRole");
    }

    FB.logout(function (response) {});
    store.commit("authCheck", false);
    store.commit("sitterId", "");
    store.commit("customerId", "");
    store.commit("email", "");
    store.commit("firstName", "");
    store.commit("lastName", "");
    store.commit("userRole", "");
    store.commit("profilePicUrl", "");
    router.push({ path: "/login" });
    router.go({ path: "/login" }); //workaround for refreshing the page and keeping path at /login.., some browsers dont properly clear localStorage unless refreshed, maybe remove in future.
  },
  checkTokenExpiry() {
    /*Checking if token has expired*/
    if (localStorage.getItem("access_token") != null) {
      var loggedDate = moment(JSON.parse(localStorage.getItem("loggedDate"))); //JSON parse to get red of moment warning for ISO string datetime issues.
      var currentDate = moment();
      var difference = currentDate.diff(loggedDate, "seconds");
      if (difference >= localStorage.getItem("expires")) {
        swal(
          "Session Expired",
          "Your session expired, please login again to continue.",
          "info"
        );
        this.logout();
      }
    }
  },
  getAuthHeader() {
    var data = localStorage.getItem("access_token");
    return data;
  },
  checkToken() {
    if (localStorage.getItem("access_token")) {
      store.commit("authCheck", true);
    }
    if (localStorage.getItem("phoneConfirmed") == "True") {
      store.commit("phoneConfirmed", true);
    }
  },
};



// WEBPACK FOOTER //
// ./src/auth/index.js